import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import PublicPage from './pages/PublicPage';
import OrganizerPage from './pages/OrganizerPage';
import ResellersPage from './pages/ResellersPage';
import BecomeMerchantPage from './pages/BecomeMerchantPage';
import CustomerAuthPage from './pages/CustomerAuthPage';
import ReportsPage from './pages/ReportsPage';
import VerifyTicketPage from './pages/VerifyTicketPage';
import MyTicketsPage from './pages/MyTicketsPage';
import MerchantPage from './pages/MerchantPage';
import ControllerPage from './pages/ControllerPage';
import AdminPage from './pages/AdminPage';
import './index.css';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" />;
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === 'admin') return <Navigate to="/admin" />;
    if (user.role === 'merchant') return <Navigate to="/merchant" />;
    return <Navigate to="/scan" />;
  }
  return children;
};

const HomeRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" />;
  if (user.role === 'admin') return <Navigate to="/admin" />;
  if (user.role === 'merchant') return <Navigate to="/merchant" />;
  return <Navigate to="/scan" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/events" element={<PublicPage />} />
          <Route path="/organisateur" element={<OrganizerPage />} />
          <Route path="/revendeurs" element={<ResellersPage />} />
          <Route path="/devenir-revendeur" element={<BecomeMerchantPage />} />
          <Route path="/compte/connexion" element={<CustomerAuthPage />} />
          <Route path="/verifier/:reference?" element={<VerifyTicketPage />} />
          <Route path="/verifier" element={<VerifyTicketPage />} />
          <Route path="/reports" element={<ProtectedRoute allowedRoles={['admin','merchant']}><ReportsPage /></ProtectedRoute>} />
          <Route path="/compte/mes-billets" element={<MyTicketsPage />} />
          <Route path="/merchant" element={
            <ProtectedRoute allowedRoles={['merchant', 'admin']}>
              <MerchantPage />
            </ProtectedRoute>
          } />
          <Route path="/scan" element={
            <ProtectedRoute allowedRoles={['controller', 'admin']}>
              <ControllerPage />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminPage />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;